import { hasPermission } from './permission';

const sectionRedirectMap = [
  { section: 'dashboard', keys: ['dashboard_view'], path: '/tc/dashboard' },
  { section: 'job board', keys: ['jobboard_view','jobboard_edit'], path: '/tc/jobboard' },
  { section: 'my jobs', keys: ['myjobs_view','myjobs_edit'], path: '/tc/myjobs' },
  { section: 'invoices', keys: ['invoices_view'], path: '/tc/invoices' },
  { section: 'drivers', keys: ['drivers_view', 'drivers_edit'], path: '/tc/drivers' },
  { section: 'trucks', keys: ['trucks_view', 'trucks_edit'], path: '/tc/trucks' },
  { section: 'site users', keys: ['siteusers_view', 'siteusers_edit'], path: '/tc/siteusers' },
  { section: 'notes', keys: ['notes_view'], path: '/tc/notes' },
  { section: 'notifications', keys: ['notifications_view','notifications_manage'], path: '/tc/notifications' },
  { section: 'settings', keys: ['settings_view', 'settings_edit'], path: '/tc/settings' },
];

export const getFirstPermittedRoute = () => {
  for (const item of sectionRedirectMap) {
    if (hasPermission({ section: item.section, keys: item.keys })) {
      return item.path;
    }
  }
  return null;
};
